<template>
  <v-btn
    @click="emit('click', value)"
    :data-cy="`${value}_tab`"
    :variant="currentValue != value ? 'outlined' : 'flat'"
    class="focus-very-visible me-3 my-1"
    color="primary"
  >
    {{ $bct(label) }}
  </v-btn>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  currentValue: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['click']);
</script>
